import { useState, useContext, useMemo, useCallback, useRef } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import CenterCell from '../../../components/table/CenterCell';
import ServerPaginatedTable from '../../../components/table/ServerPaginatedTable';
import TestsModal from './TestsModal';
import AppContext from '../../../context/HeaderContext';
import Duration from '../../../components/Duration';
import styled from 'styled-components';
import { getAPI } from '../../../libs/fetchAPI';
import RightCell from '../../../components/table/RightCell';
import IntroMessage from '../../../components/IntroMessage';

const CustomCenterCell = styled(CenterCell)`
	width : 100%;
	min-width : 205px;
`;

function AllSuites({ selected_filter }) {
	const { current_project_id }                          = useContext(AppContext);
	const [ loading, setLoading ]                         = useState(false);
	const [ page_count, setPageCount ]                    = useState();
	const [ show_tests_modal, setShowTestsModal ]         = useState(false);
	const [ current_suite_params, setCurrentSuiteParams ] = useState();
	const [ suites, setSuites ]                           = useState([]);
	const fetch_id_ref                                    = useRef(0);

	/* eslint-disable */
	const fetchTableData = useCallback(({ pageIndex, pageSize, filters, sortBy }) => {
		console.log(fetch_id_ref.current);
		const fetch_id = ++fetch_id_ref.current;

		if(fetch_id !== fetch_id_ref.current) {
			return;
		}

		let sort_key       = `spec_file`;
		let sort_direction = `DESC`;

		if(sortBy.length) {
			sort_key       = sortBy[0].id;
			sort_direction = sortBy[0].desc ? `DESC` : `ASC`;
		}

		const params = {
			project_id     : current_project_id,
			limit          : pageSize,
			offset         : pageSize * pageIndex,
			filters        : JSON.stringify(filters),
			date_range     : selected_filter,
			sort_key,
			sort_direction,
		};

		setLoading(true);
		getAPI(`/suite_info?${new URLSearchParams(params).toString()}`)
			.then(({ data, pages }) => {
				setSuites(data);
				setPageCount(pages);
				setLoading(false);
			});
	}, [current_project_id, selected_filter]);
	/* eslint-enable */

	/*
	useEffect(() => {
		const params = {
			project_id     : current_project_id,
			sort_key       : `spec_file`,
			sort_direction : `ASC`,
			date_range     : selected_filter,
			limit          : 10000,
		};

		setLoading(true);
		getAPI(`/suite_info?${new URLSearchParams(params)}`)
			.then(({ data, pages }) => {
				setSuites(data);

				setPageCount(pages);
				setLoading(false);
			});
	}, [current_project_id, selected_filter]);
	*/

	function handleViewTests(params) {
		setShowTestsModal(true);
		setCurrentSuiteParams(params);
	}

	function handleCloseTests() {
		setShowTestsModal(false);
	}

	/* eslint-disable */
	const columns = useMemo(() => [
		{
			Header   : `Spec File`,
			accessor : `spec_file`,
		},
		{
			Header   : `Title`,
			accessor : `title`,
		},
		{
			Header   : `Version`,
			accessor : `version`,
			Cell     : ({ cell }) => <RightCell>{cell.value || `N/A`}</RightCell>
		},
		{
			Header   : `Passes`,
			accessor : `passes`,
			Cell     : ({ cell }) => <RightCell>{cell.value}</RightCell>
		},
		{
			Header   : `Fails`,
			accessor : `fails`,
			Cell     : ({ cell }) => <RightCell>{cell.value}</RightCell>
		},
		{
			Header   : `Skipped`,
			accessor : `skips`,
			Cell     : ({ cell }) => <RightCell>{cell.value}</RightCell>
		},
		{
			Header   : `Retries`,
			accessor : `retries`,
			Cell     : ({ cell }) => <RightCell>{cell.value}</RightCell>
		},
		{
			Header   : `Retry %`,
			accessor : `retry_percent`,
			collapse : true,
			Cell     : ({ cell }) => <RightCell>{cell.value}%</RightCell>
		},
		{
			Header   : `Pass %`,
			accessor : `pass_percent`,
			collapse : true,
			Cell     : ({ cell }) => <RightCell>{cell.value}%</RightCell>
		},
		{
			Header   : `Average Duration`,
			accessor : `average_duration`,
			Cell     : ({ cell }) => <RightCell><Duration duration={cell.value} /></RightCell>
		},
		{
			Header         : `Active`,
			accessor       : `disabled`,
			collapse       : true,
			disableFilters : true,
			Cell           : ({ cell }) => {
				const name  = !cell.value ? `check` : `cancel`;
				const color = !cell.value ? `green` : `red`;

				return <CenterCell><Icon name={name} color={color} /></CenterCell>
			}
		},
		{
			Header         : ``,
			accessor       : `id`,
			collapse       : true,
			disableFilters : true,
			Cell           : ({ cell }) => {
				const row    = cell.row.values;
				const params = {
					spec_file  : row.spec_file,
					version    : row.version || ``,
					project_id : current_project_id,
				};

				const link = `${window.location.origin}/suites/single?${new URLSearchParams(params)}`;

				return (
					<CustomCenterCell>
						<Button color="teal" onClick={() => handleViewTests(params)}>Tests</Button>
						<a href={link} target="_blank" rel="noreferrer"><Button primary><span>View</span><span>&nbsp;&nbsp;<Icon name="external" /></span></Button></a>
					</CustomCenterCell>
				)
			}
		}
	], []);
	/* eslint-enable */

	return (
		<>
			<IntroMessage
				id={3}
				message='The Spec History -> Suites page shows a summary of how each suite has performed accross all test runs. Clicking the "View" button will show you how the suite performed on each individual test run.'
			/>

			<TestsModal
				open={show_tests_modal}
				suite_params={current_suite_params}
				handleClose={handleCloseTests}
			/>

			<ServerPaginatedTable
				columns={columns}
				data={suites}
				fetchTableData={fetchTableData}
				loading={loading}
				pageCount={page_count}
				current_project_id={current_project_id}
				selected_filter={selected_filter}
				default_page_size="10"
			/>
		</>
	);
}

export default AllSuites;
